import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import Translate from "../../translation/Translate";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import i18next from "i18next";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class RevisedStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		let date: Date = new Date(FunctionHelper.applyValue(this.props.date, 0));
		let minutes: string = date.getMinutes().toString().padStart(2, "0");
		let hours: string = date.getHours().toString().padStart(2, "0");
		let days: string = date.getDate().toString().padStart(2, "0");
		let months: string = (date.getMonth() + 1).toString().padStart(2, "0");

		let dateString: string = i18next.language === "de" ?
			hours + ":" + minutes + ", " + days + "." + months + "." + date.getFullYear() :
			hours + ":" + minutes + ", " + months + "." + days + "." + date.getFullYear();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 300 116"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2={0}>
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#E7F0F5"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#CCD6E4"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<rect x={1} y={1} rx={5} ry={5} width={298} height={114} className="movearea"
                              onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
							  onPointerDown={this.props.onMoveStart}/>
					}
					<rect x={1} y={1} rx={5} ry={5} width={298} height={114} style={{
						fill: "#E7F0F5",
						strokeWidth: 1,
						stroke: "#244C7A"
					}}/>
					<text x={5} y={50} style={{
						fontWeight: "bold",
						fontStyle: "italic",
						textAnchor: "start",
						textTransform: "uppercase",
						fill: "#244C7A",
						fontSize: "36px"
					}}>
						<Translate {...this.props} data="annotation.stamp_types.revised" namespace="sidebar"/>
					</text>
					<text x="50%" y={95} style={{
						fontWeight: "bold",
						fontStyle: "italic",
						textAnchor: "middle",
						fill: "#172663",
						fontSize: "36px"
					}}>{dateString}</text>
				</g>
			</svg>
		);
	}
}